// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================= */
/* INPUT COMPONENT STYLES - VANTA INSPIRED     */
/* ============================================= */

.input-wrapper,
.textarea-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

/* Input Label */
.input-label,
.textarea-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #334155;
  line-height: 1.5;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.dark .input-label,
.dark .textarea-label {
  color: #E2E8F0;
}

.input-required,
.textarea-required {
  color: #EC4899;
  margin-left: 0.25rem;
}

/* Input Container with Icon */
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 1rem;
  width: 1.25rem;
  height: 1.25rem;
  color: #94A3B8;
  pointer-events: none;
  flex-shrink: 0;
}

.dark .input-icon {
  color: #64748B;
}

/* Base Input Styles */
.input {
  width: 100%;
  padding: 0.625rem 1rem;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.625rem;
  border: 1px solid #E2E8F0;
  background-color: white;
  color: #0F172A;
  transition: all 200ms ease-in-out;
}

.dark .input {
  background-color: #1E293B;
  border-color: #334155;
  color: #F8FAFC;
}

.input:focus {
  outline: none;
  border-color: var(--app-primary-color, #26256b);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--app-primary-color, #26256b) 15%, transparent);
  caret-color: var(--app-primary-color, #26256b);
}

.input:disabled {
  background-color: #F8FAFC;
  color: #94A3B8;
  cursor: not-allowed;
}

.dark .input:disabled {
  background-color: #0F172A;
  color: #64748B;
}

/* Input with Icon */
.input-container .input {
  padding-left: 3rem;
}

/* Input Sizes */
.input-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

.input-md {
  padding: 0.625rem 1rem;
  font-size: 1rem;
}

.input-lg {
  padding: 0.875rem 1.25rem;
  font-size: 1.125rem;
}

/* Input Variants */
.input-outlined {
  border: 1px solid #E2E8F0;
  background-color: #FFFFFF;
}

.input-filled {
  border: none;
  background-color: #F8FAFC;
}

.dark .input-filled {
  background-color: #0F172A;
}

.input-filled:focus {
  background-color: white;
}

.dark .input-filled:focus {
  background-color: #1E293B;
}

.input-underline {
  border: none;
  border-bottom: 2px solid #E2E8F0;
  border-radius: 0;
  padding: 0.5rem 0;
}

.dark .input-underline {
  border-bottom-color: #334155;
}

.input-underline:focus {
  border-bottom-color: var(--app-primary-color, #26256b);
  box-shadow: none;
  caret-color: var(--app-primary-color, #26256b);
}

/* Input Error State */
.input-error {
  border-color: #EC4899;
}

.input-error:focus {
  border-color: #ec4899;
  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.1);
}

/* Input Error Message */
.input-error-message,
.textarea-error-message {
  font-size: 0.75rem;
  color: #EC4899;
  line-height: 1.4;
  margin-top: 0.25rem;
}

.dark .input-error-message,
.dark .textarea-error-message {
  color: #F472B6;
}

/* Input Help Text */
.input-help-text,
.textarea-help-text {
  font-size: 0.75rem;
  color: #94A3B8;
  line-height: 1.4;
  margin-top: 0.25rem;
}

.dark .input-help-text,
.dark .textarea-help-text {
  color: #64748B;
}

/* Full Width */
.input-full-width,
.textarea-full-width {
  width: 100%;
}

/* ============================================= */
/* TEXTAREA COMPONENT STYLES                    */
/* ============================================= */

.textarea {
  width: 100%;
  padding: 0.625rem 1rem;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.625rem;
  border: 1px solid #E2E8F0;
  background-color: white;
  color: #0F172A;
  resize: vertical;
  transition: all 200ms ease-in-out;
}

.dark .textarea {
  background-color: #1E293B;
  border-color: #334155;
  color: #F8FAFC;
}

.textarea:focus {
  outline: none;
  border-color: var(--app-primary-color, #26256b);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--app-primary-color, #26256b) 15%, transparent);
  caret-color: var(--app-primary-color, #26256b);
}

.textarea:disabled {
  background-color: #F8FAFC;
  color: #94A3B8;
  cursor: not-allowed;
}

.dark .textarea:disabled {
  background-color: #0F172A;
  color: #64748B;
}

.textarea-error {
  border-color: #EC4899;
}

.textarea-error:focus {
  border-color: #EC4899;
  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.1);
}

`, "",{"version":3,"sources":["webpack://./src/components/ui/styles/Input.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD,gDAAgD;AAChD,kDAAkD;;AAElD;;EAEE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA,gBAAgB;AAChB;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,sBAAsB;EACtB,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,4FAA4F;EAC5F,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,wBAAwB;AACxB;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;;EAEE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;;EAEE,WAAW;AACb;;AAEA,kDAAkD;AAClD,iDAAiD;AACjD,kDAAkD;;AAElD;EACE,WAAW;EACX,sBAAsB;EACtB,0DAA0D;EAC1D,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,4FAA4F;EAC5F,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["/* ============================================= */\n/* INPUT COMPONENT STYLES - VANTA INSPIRED     */\n/* ============================================= */\n\n.input-wrapper,\n.textarea-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n/* Input Label */\n.input-label,\n.textarea-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #334155;\n  line-height: 1.5;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n}\n\n.dark .input-label,\n.dark .textarea-label {\n  color: #E2E8F0;\n}\n\n.input-required,\n.textarea-required {\n  color: #EC4899;\n  margin-left: 0.25rem;\n}\n\n/* Input Container with Icon */\n.input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 1rem;\n  width: 1.25rem;\n  height: 1.25rem;\n  color: #94A3B8;\n  pointer-events: none;\n  flex-shrink: 0;\n}\n\n.dark .input-icon {\n  color: #64748B;\n}\n\n/* Base Input Styles */\n.input {\n  width: 100%;\n  padding: 0.625rem 1rem;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.625rem;\n  border: 1px solid #E2E8F0;\n  background-color: white;\n  color: #0F172A;\n  transition: all 200ms ease-in-out;\n}\n\n.dark .input {\n  background-color: #1E293B;\n  border-color: #334155;\n  color: #F8FAFC;\n}\n\n.input:focus {\n  outline: none;\n  border-color: var(--app-primary-color, #26256b);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--app-primary-color, #26256b) 15%, transparent);\n  caret-color: var(--app-primary-color, #26256b);\n}\n\n.input:disabled {\n  background-color: #F8FAFC;\n  color: #94A3B8;\n  cursor: not-allowed;\n}\n\n.dark .input:disabled {\n  background-color: #0F172A;\n  color: #64748B;\n}\n\n/* Input with Icon */\n.input-container .input {\n  padding-left: 3rem;\n}\n\n/* Input Sizes */\n.input-sm {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.875rem;\n}\n\n.input-md {\n  padding: 0.625rem 1rem;\n  font-size: 1rem;\n}\n\n.input-lg {\n  padding: 0.875rem 1.25rem;\n  font-size: 1.125rem;\n}\n\n/* Input Variants */\n.input-outlined {\n  border: 1px solid #E2E8F0;\n  background-color: #FFFFFF;\n}\n\n.input-filled {\n  border: none;\n  background-color: #F8FAFC;\n}\n\n.dark .input-filled {\n  background-color: #0F172A;\n}\n\n.input-filled:focus {\n  background-color: white;\n}\n\n.dark .input-filled:focus {\n  background-color: #1E293B;\n}\n\n.input-underline {\n  border: none;\n  border-bottom: 2px solid #E2E8F0;\n  border-radius: 0;\n  padding: 0.5rem 0;\n}\n\n.dark .input-underline {\n  border-bottom-color: #334155;\n}\n\n.input-underline:focus {\n  border-bottom-color: var(--app-primary-color, #26256b);\n  box-shadow: none;\n  caret-color: var(--app-primary-color, #26256b);\n}\n\n/* Input Error State */\n.input-error {\n  border-color: #EC4899;\n}\n\n.input-error:focus {\n  border-color: #ec4899;\n  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.1);\n}\n\n/* Input Error Message */\n.input-error-message,\n.textarea-error-message {\n  font-size: 0.75rem;\n  color: #EC4899;\n  line-height: 1.4;\n  margin-top: 0.25rem;\n}\n\n.dark .input-error-message,\n.dark .textarea-error-message {\n  color: #F472B6;\n}\n\n/* Input Help Text */\n.input-help-text,\n.textarea-help-text {\n  font-size: 0.75rem;\n  color: #94A3B8;\n  line-height: 1.4;\n  margin-top: 0.25rem;\n}\n\n.dark .input-help-text,\n.dark .textarea-help-text {\n  color: #64748B;\n}\n\n/* Full Width */\n.input-full-width,\n.textarea-full-width {\n  width: 100%;\n}\n\n/* ============================================= */\n/* TEXTAREA COMPONENT STYLES                    */\n/* ============================================= */\n\n.textarea {\n  width: 100%;\n  padding: 0.625rem 1rem;\n  font-family: 'Inter', system-ui, -apple-system, sans-serif;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0.625rem;\n  border: 1px solid #E2E8F0;\n  background-color: white;\n  color: #0F172A;\n  resize: vertical;\n  transition: all 200ms ease-in-out;\n}\n\n.dark .textarea {\n  background-color: #1E293B;\n  border-color: #334155;\n  color: #F8FAFC;\n}\n\n.textarea:focus {\n  outline: none;\n  border-color: var(--app-primary-color, #26256b);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--app-primary-color, #26256b) 15%, transparent);\n  caret-color: var(--app-primary-color, #26256b);\n}\n\n.textarea:disabled {\n  background-color: #F8FAFC;\n  color: #94A3B8;\n  cursor: not-allowed;\n}\n\n.dark .textarea:disabled {\n  background-color: #0F172A;\n  color: #64748B;\n}\n\n.textarea-error {\n  border-color: #EC4899;\n}\n\n.textarea-error:focus {\n  border-color: #EC4899;\n  box-shadow: 0 0 0 3px rgba(236, 72, 153, 0.1);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
